export let calendarMonth_April = "$U5Lkc";
export default {calendarMonth_April};